/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingStatus =
    (typeof BuildingStatus)[keyof typeof BuildingStatus];

export const BuildingStatus = {
    Draft: 1,
    Published: 2,
} as const;
